export interface InputState {
  /**
   * State used to handle Safari's odd behavior of not triggering a change
   * when we mutate the value of the input with formatting (adding commas for
   * numbers). We use this state to force a change event to be triggered on blur
   * if the input value has changed.
   *
   * Ideally Safari will fix this issue and we can remove this state and all code
   * that references it.
   */
  nextBlurShouldTriggerChange: boolean;
  textWidth: number | null;
  value: string;
}

export enum InputType {
  Text = `text`,
  Password = `password`,
  Number = `number`,
  TextArea = `textarea`,
}

export enum InputSize {
  Small = `small`,
  Medium = `medium`,
  Large = `large`,
}

export enum InputTheme {
  Default = `default`,
  White = `white`,
}

export enum Necessary {
  Default = ``,
  Optional = `optional`,
  Recommended = `recommended`,
  Required = `required`,
}

export enum ValidationStatus {
  Default = ``,
  Valid = `valid`,
  Invalid = `invalid`,
}

export enum TextAlign {
  Start = `start`,
  Center = `center`,
  End = `end`,
}

export enum AutocompleteType {
  CurrentPassword = `current-password`,
  NewPassword = `new-password`,
  Email = `email`,
  InviteUsersAutocompleteOff = `invite-users-autocomplete-off`,
  Off = `off`,
}

// Replace with React type after conversion?
type GenericEvent<T> = Event & {
  target: T;
};
type GenericInputEvent<T> = InputEvent & {
  target: T;
};

export type InputChangeEvent = GenericEvent<HTMLInputElement | HTMLTextAreaElement>;
export type InputInputEvent = GenericInputEvent<HTMLInputElement | HTMLTextAreaElement>;
